import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import TextField from 'Components/UI/TextField';
import { DataValueMap } from 'Helpers/Testing';
import { useMessagesContext } from 'Views/Page/Content/Templates/MessagesPage/MessagesContext';

const useStyles = buildUseStyles('ComposeMessageSubject', () => ({
  root: {},
}));

const ComposeMessageSubject = ({
  className,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const {
    composeDraftMessageResource,
    setComposeDraftMessageSubject,
    autoSaveComposeDraft,
  } = useMessagesContext();

  const value = composeDraftMessageResource?.attr('subject') ? composeDraftMessageResource.attr('subject') : '';

  const handleChange = (subject) => {
    composeDraftMessageResource.attr('subject', subject);
    setComposeDraftMessageSubject(composeDraftMessageResource.attr('subject'));
    autoSaveComposeDraft(composeDraftMessageResource);
  };

  return (
    <Box className={classNames(className, classes.root)}>
      <TextField
        label="Subject:"
        fullWidth
        onChange={(e) => handleChange(e.target.value)}
        value={value}
        {...DataValueMap.init('messages-page-compose-dock-subject-input').build()}
      />
    </Box>
  );
};

ComposeMessageSubject.defaultProps = {
  className: '',
};

ComposeMessageSubject.propTypes = {
  className: PropTypes.string,
};

export { ComposeMessageSubject };
